import { useContextCurrency } from '@core/context';
import { useLanguage } from '@core/hook';
import { EActionAttribute, EFontWeight, ETypographyVariant } from '@core/type';
import { formatCurrencyArray } from '@core/util';

import { Typography } from './Typography';
import { TextPriceProps } from './interface-typography';

export const getTextPriceCurrencyProps = (props: Intl.NumberFormatPart[]) => ({
  integerValues: props.filter(
    ({ type }) => !['currency', 'literal', 'decimal', 'fraction'].includes(type),
  ),
  decimal: props.find(({ type }) => type === 'decimal')?.value,
  fraction: props.find(({ type }) => type === 'fraction')?.value,
  literal: props.find(({ type }) => type === 'literal')?.value,
  currency: props.find(({ type }) => type === 'currency')?.value,
});

export const TextPrice = ({
  price,
  currency: currencyProps,
  integerProps,
  fractionProps,
  variant = ETypographyVariant.H4,
  ...restProps
}: TextPriceProps) => {
  const { language } = useLanguage();
  const { currency: currencyContext } = useContextCurrency();
  const priceProps = formatCurrencyArray(language, currencyProps || currencyContext, price);
  const isCurrencyAtTheBeginning = priceProps[0].type === 'currency';
  const { currency, decimal, literal, fraction, integerValues } =
    getTextPriceCurrencyProps(priceProps);

  if (isCurrencyAtTheBeginning) {
    return (
      <Typography whiteSpace={'nowrap'} {...restProps}>
        <Typography variant={variant} as={EActionAttribute.SPAN} {...integerProps}>
          {currency}
          {integerValues.map(({ value }) => value)}
          {decimal}
        </Typography>
        <Typography as={EActionAttribute.SPAN} fontWeight={EFontWeight.BOLD} {...fractionProps}>
          {fraction}
        </Typography>
      </Typography>
    );
  }

  return (
    <Typography whiteSpace={'nowrap'} {...restProps}>
      <Typography variant={variant} as={EActionAttribute.SPAN} {...integerProps}>
        {integerValues.map(({ value }) => value)}
      </Typography>
      <Typography as={EActionAttribute.SPAN} fontWeight={EFontWeight.BOLD} {...fractionProps}>
        {decimal}
        {fraction}
        {literal}
      </Typography>
      <Typography variant={variant} as={EActionAttribute.SPAN} {...integerProps}>
        {currency}
      </Typography>
    </Typography>
  );
};
